const groupPrefix = createApiRoute(ApiModule.CLIENT, ApiAuthorization.EMPLOYEE, ApiDataModel.LOYALTY_POINTS)

export const apiLoyaltyPoints = {
	fetchLoyaltyPoints: async (uuid: string): Promise<IPointLoyaltyPointModel> => {
		const { data } = await apiCommon<IPointLoyaltyPoint[]>(`${groupPrefix}`, {
			method: 'GET',
			...createQuery(undefined, { client_uuid: uuid }),
		})

		return PointLoyaltyPoint(data[0])
	},
	createClientLoyaltyPoints: async (payload: IPointLoyaltyPointPayload): Promise<IPointLoyaltyPointModel> => {
		const { data } = await apiCommon<IPointLoyaltyPoint>(`${groupPrefix}`, {
			method: 'POST',
			body: payload,
		})

		return PointLoyaltyPoint(data)
	},
}
